import styled from "styled-components";

const StyledFormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 1rem 0;
    font-size: 0.8rem;
`;

const Label = styled.label`
  font-weight: 200;
`;

const Error = styled.span`
  font-size: 0.5rem;
  color: var(--color-red-700);
`;

function FormRowVertical({ label, error, children }) {
    return (
        <StyledFormRow>
            {label && <Label htmlFor={children.props.id}>{label}</Label>}
            {children}
            {error && <Error>{error}</Error>}
        </StyledFormRow>
    );
}

export default FormRowVertical;
